import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.7.293a.98.98 0 0 0-1.4 0L6 10.363 1.7 6.16a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.37l5 4.886c.2.196.4.294.7.294s.5-.098.7-.294l11-10.753a.93.93 0 0 0 0-1.369"
    }, null, -1)
  ]))]))
}
export default { render: render }